<!--
2023-05-24 Matt 常态化下注流水返利活动
-->
<template>
  <div class="betActivityRegularlyPage">
    <TopBack :title="$t('lang.common.freeCash')" :handelBack="goBack"/>
    <div class="nav-bar">
      <div class="act">
        <span>{{ $t('lang.betActivityRegularly.cashbackRewards') }}</span>
        <div class="redPoint" v-show="$store.state.BetRewardHot===true"/>
      </div>
      <div class="nav" @click="goto('CashBack')">
        <span>{{ $t('lang.cashback.route') }}</span>
        <div class="redPoint" v-show="$store.state.CashBackHot===true"/>
      </div>
    </div>
    <div class="banner">
      <img
        v-show="topImage"
        class="top-image"
        alt="Rebate"
        :src="topImage"
      >
    </div>
    <div class="slogan">{{ $t('lang.betActivityRegularly.slogan') }}</div>
    <div class="summary">
      <div class="available">
        <div class="title">
          {{ $t('lang.betActivityRegularly.rewardsAvailable') }}
        </div>
        <div class="amount">
          {{ userInfo ? fetchCurrency[userInfo.CurrencyName] : '' }}{{ separateThousand(rewardsAvailable) }}
        </div>
      </div>
      <div class="separator"></div>
      <div class="received">
        <div class="title">
          {{ $t('lang.betActivityRegularly.totalReceived') }}
        </div>
        <div class="amount">
          {{ userInfo ? fetchCurrency[userInfo.CurrencyName] : '' }}{{ separateThousand(totalReceived) }}
        </div>
      </div>
    </div>
    <div class="buttons">
      <button @click="onClaimNow">
        {{ $t('lang.betActivityRegularly.claimNow') }}
      </button>
<!--      <button @click="onPlay">-->
<!--        {{ $t('lang.betActivityRegularly.playNow') }}-->
<!--      </button>-->
    </div>
    <div class="links">
      <span @click="() => $router.push('/BetActivityRegularlyRules')">
        {{ $t('lang.betActivityRegularly.rules') }}
      </span>
      <span @click="onDetails">
        {{ $t('lang.betActivityRegularly.details') }}
      </span>
    </div>
    <div class="tipBox">
      <div class="tipTitle" v-html="replaceRow($t('lang.betActivityRegularly.tipTitle'))"></div>
      <div class="tips" v-html="replaceRow($t('lang.betActivityRegularly.tips'))"></div>
    </div>
    <div class="modal" v-if="isModalShowing">
      <div class="content">
        <div class="claimedTitle" v-if="claimedSuccessOrFailed">
          {{ $t('lang.betActivityRegularly.Success') }}
        </div>
        <div class="claimResult" v-if="claimedSuccessOrFailed">
          {{ $t('lang.betActivityRegularly.claimResultSuccess') }}
        </div>
        <div class="claimResult" v-else>
          {{ $t('lang.betActivityRegularly.claimResultFailed') }}
        </div>
        <div class="claimResultNotReached" v-if="!claimedSuccessOrFailed">
          {{ $t('lang.betActivityRegularly.claimResultNotReached') }}
        </div>
        <button @click="onPlay">
          {{ $t('lang.betActivityRegularly.playNow') }}
        </button>
        <div class="cancel" @click="closeModal">
          {{ $t('lang.betActivityRegularly.cancel') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import {separateThousand, fetchBalance, LogUtils} from '@/utils'
import {fetchCurrency} from '@/constant'
import TopBack from '@/components/TopBack/index'

export default {
  name: 'betActivityRegularly',
  data () {
    return {
      topImage: null,
      fetchBalance,
      separateThousand,
      fetchCurrency,
      accountInfo: {},
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      rewardsAvailable: 0,
      totalReceived: 0,
      isModalShowing: false,
      claimedSuccessOrFailed: false
    }
  },
  components: {
    TopBack
  },
  mounted () {
    this.getTotalSummary()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name && (from.name === 'Home' || from.name === 'Promotion' || from.name === 'Vip' || from.name === 'SportsBetting')) {
        vm.$store.commit('setFreeCashBackRoute', from.name)
      }
    })
  },
  methods: {
    replaceRow (val) {
      if (val) {
        return String(val).replace(/\n/g, '<br>')
      }
    },
    goBack () {
      this.$router.push('/' + this.$store.state.freeCashBackRoute)
    },
    getTotalSummary () {
      // if (this.userInfo) {
      const userUniqueId = this.userInfo ? this.userInfo.UserId : null
      request('post', '/innovation/activity-normal/get-total-reward', {
        UserId: userUniqueId
      }, true).then(res => {
        this.topImage = res.HeaderUrl
        this.totalReceived = res.TotalReceived
        this.rewardsAvailable = res.TotalRewards - res.TotalReceived
      })
      document.getElementById('loading').style.display = 'none'
      // }
    },
    onPlay () {
      this.$router.push('/Home')
    },
    goto (path) {
      this.$router.push('/' + path)
    },
    onClaimNow () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        // this.$store.commit('setLoginPopShow', true)
      }
      const that = this
      const userUniqueId = this.userInfo.UserId
      request('post', '/innovation/activity-normal/receive-reward', {
        UserId: userUniqueId
      }).then(res => {
        this.$store.commit('setBetRewardHot', false)
        if (res > 0) {
          LogUtils.logout9w()
          this.fetchBalance()
          this.claimedSuccessOrFailed = true
        } else {
          this.claimedSuccessOrFailed = false
        }
        this.getTotalSummary()
        that.isModalShowing = true
      })
    },
    closeModal () {
      this.isModalShowing = false
    },
    onDetails () {
      if (this.userInfo) {
        this.$router.push('/BetActivityRegularlyDetails')
      } else {
        this.$router.push('/Login')
        // this.$store.commit('setLoginPopShow', true)
      }
    }
  }
}

</script>

<style lang="less" scoped>
.betActivityRegularlyPage {
  background-color: #150F0F;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 56px 0 100px 0;
  overflow-x: hidden;

  .nav-bar {
    margin: 3vw auto;
    width: 82vw;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      width: 40.555vw;
      text-align: center;
      font-size: 5vw;
      font-weight: 400;
      height: 7.13vw;
    }

    .nav {
      position: relative;
      color: #5C5C5C;
      border-bottom: 0.8vw solid transparent;
    }

    .act {
      position: relative;
      color: #F6D9AA;
      border-bottom: 0.8vw solid #F6D9AA;
    }

    .redPoint {
      position: absolute;
      top: 0;
      right: 0;
      width: 2.3vw;
      height: 2.3vw;
      border-radius: 50%;
      background: red;
    }
  }

  .banner {
    width: 86.66vw;
    height: 33.61vw;
    margin: 5px 24px;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .slogan {
    width: 86.666vw;
    font-size: 4.444vw;
    font-weight: 400;
    color: #E5E4E3;
    margin: 1.667vw auto 3.2vw auto;
    line-height: 5vw;
  }

  .summary {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 12vh;
    margin: 0px 24px 0;
    background-color: #2d2a26;
    border-radius: 8px;

    .available {
      text-align: center;
      line-height: 32px;

      .title {
        font-size: 18px;
        font-weight: 700;
        color: #f1dab0;
      }

      .amount {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
      }
    }

    .separator {
      height: 60%;
      border-left: rgba(217, 217, 217, 0.2) 1px solid;
    }

    .received {
      text-align: center;
      line-height: 32px;

      .title {
        font-size: 18px;
        font-weight: 700;
        color: #f1dab0;
      }

      .amount {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 24px 0;

    button {
      height: 48px;
      width: 80%;
      background-color: #f1dab0;
      border: none;
      border-radius: 8px;
      font-size: 22px;
      font-weight: 700;
      color: #220303;

      &:first-of-type {
        margin-bottom: 8px;
      }
    }
  }

  .links {
    display: flex;
    align-items: center;
    margin-top: 30px;
    justify-content: center;
    gap: 9.166vw;
    span{
      border-bottom: 1px solid;
    }
    a {
      display: block;
      color: #5b5d5d;
      text-decoration: none;
    }
  }
  .tipBox{
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    gap: 1.666vw;
    //height: 48.888vw;
    //overflow-y: auto;
    //overflow-x: hidden;
    margin-top: 3.888vw;
    .tipTitle{
      width: 90.477vw;
      color: #E5CB9C;
      font-size: 3.888vw;
    }
    .tips{
      width: 90.477vw;
      color: #757575;
      font-size: 3.888vw;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
    @media screen and (max-height: 750px) {
      .content {
        width: 88vw;
        height: 81vw;
        margin: 74vw auto;
        padding: 24px;
        background: #1c1c1e;
        border: #737373 2px solid;
        border-radius: 15px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

        .claimedTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          color: #ffffff;
          line-height: 32px;
        }

        .claimResult {
          width: 100%;
          margin: 28px 0;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
        }

        .claimResultNotReached {
          width: 100%;
          margin: 20px 10px;
          font-size: 14px;
          font-weight: 400;
          color: #cc1313;
          line-height: 20px;
        }

        button {
          height: 44px;
          width: 100%;
          background-color: #f1dab0;
          border: none;
          border-radius: 8px;
          font-size: 20px;
          font-weight: 700;
          color: #220303;
        }

        .cancel {
          width: 100%;
          margin-top: 22px;
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          color: #696969;
        }
      }
    }
    @media screen and (min-height: 751px) {
      .content {
        width: 88vw;
        height: 78vw;
        margin: 74vw auto;
        padding: 24px;
        background: #1c1c1e;
        border: #737373 2px solid;
        border-radius: 15px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

        .claimedTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          color: #ffffff;
          line-height: 32px;
        }

        .claimResult {
          width: 100%;
          margin: 28px 0;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
        }

        .claimResultNotReached {
          width: 100%;
          margin: 20px 10px;
          font-size: 14px;
          font-weight: 400;
          color: #cc1313;
          line-height: 20px;
        }

        button {
          height: 48px;
          width: 100%;
          background-color: #f1dab0;
          border: none;
          border-radius: 8px;
          font-size: 22px;
          font-weight: 700;
          color: #220303;
        }

        .cancel {
          width: 100%;
          margin-top: 22px;
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          color: #696969;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/BetActivityRegularly/index.vue